// extracted by mini-css-extract-plugin
var _1 = "#4c8bf9";
export { _1 as "blue" }
